/* eslint-disable react-refresh/only-export-components */
import {Suspense} from 'react';
import * as Sentry from '@sentry/react';
import {withProfiler} from '@sentry/react';
import DesignSwitch from 'components/DesignSwitch';
import ScrollToTop from 'utils/scrollToTop';
import AppProviders from 'context/index';
import SplashSwitch from 'components/SplashSwitch';
import {LanguageModal} from 'components/LanguageModal';
import {PartnerHandoffModal} from 'components/upselling/PartnerHandoff';
import {PaymentFlowModal} from 'components/PaymentFlowModal';
import {ErrorFallback} from 'components/ErrorFallback';
import {ChekinToaster} from '@chekinapp/ui';
import {ExpireSessionCloseModal} from 'components/ExpireSessionCloseModal';
import {LivenessModelPreloader} from 'components/LivenessModelPreloader';
import {ReservationSettingsPreloader} from 'components/ReservationSettingsModal/ReservationSettingsPreloader';
import {ViewLoader} from 'pages/Auth/components/ViewLoader';
import {BookingFoundOverlay} from 'pages/SearchReservation/components/BookingFoundOverlay';
import {MaintenanceBanner} from 'components/MaintenanceBanner';
import {onIVStateReset} from '@chekin/shared';
import {removeIVIntentRemoteSession} from 'hooks/iv/ivIntentRemoteSession';

onIVStateReset(removeIVIntentRemoteSession);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={({error}) => <ErrorFallback error={error} />}>
      <AppProviders>
        <Suspense fallback={null}>
          <MaintenanceBanner />
          <ExpireSessionCloseModal />
        </Suspense>
        <Suspense fallback={null}>
          <SplashSwitch />
        </Suspense>
        <ScrollToTop />
        <LivenessModelPreloader />
        <ReservationSettingsPreloader />
        <Suspense fallback={<ViewLoader />}>
          <DesignSwitch />
        </Suspense>
        <BookingFoundOverlay />
        <ChekinToaster />
        <Suspense fallback={null}>
          <LanguageModal />
          <PartnerHandoffModal />
          <PaymentFlowModal />
        </Suspense>
      </AppProviders>
    </Sentry.ErrorBoundary>
  );
}

export default withProfiler(App);
